import { z } from 'zod';

/** 배송지 칸 길이 상한(trim 후 UTF-16 길이) — 계약과 web 폼 maxLength 가 같은 값을 쓴다. */
export const SHIPPING_ADDRESS_MAX_LENGTHS = {
  recipientName: 50,
  recipientPhone: 20,
  postalCode: 10,
  address1: 200,
  address2: 200,
} as const;

/** 공백만 있는 값은 거부하고 앞뒤 공백은 정리한다(견적 `quoteRequiredTextSchema` 와 같은 규칙). */
const requiredAddressText = (max: number) => z.string().trim().min(1).max(max);

/**
 * 배송지 단일 계약 — 견적 요청 폼(견적 spec §5-4), 주문하기 배송지 사본(주문 spec §8-1), 주문 배송지 변경(§8-3)이 모두 이 스키마를
 * 쓴다(R14: 견적 strict 계약과 상한으로 합침). 모르는 칸은 지우지 않고 거부한다. DB(quote_requests·orders)에는 길이 CHECK 를
 * 두지 않았다 — 넣을지는 사용자 선택으로 남긴다. index 는 `schemas/quotes` 의 재노출로 내보낸다(이름 충돌 방지).
 */
export const shippingAddressSchema = z.strictObject({
  recipientName: requiredAddressText(SHIPPING_ADDRESS_MAX_LENGTHS.recipientName),
  recipientPhone: requiredAddressText(SHIPPING_ADDRESS_MAX_LENGTHS.recipientPhone),
  postalCode: requiredAddressText(SHIPPING_ADDRESS_MAX_LENGTHS.postalCode),
  address1: requiredAddressText(SHIPPING_ADDRESS_MAX_LENGTHS.address1),
  address2: requiredAddressText(SHIPPING_ADDRESS_MAX_LENGTHS.address2),
});
export type ShippingAddress = z.infer<typeof shippingAddressSchema>;
